import React from "react";
import PropTypes from "prop-types";

function Header(props) {
  const { children } = props;

  return (
    <p className="pb-4 text-xl font-bold uppercase tracking-wide">{children}</p>
  );
}

Header.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Header;
